import { Localized } from "@fluent/react";
import { ContentCopy } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

interface CopyToClipboardButtonProps {
    value: string;
    disabled?: boolean;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({ value, disabled = false }) => {

    const handleCopytoClipboardClick = async () => {
        try {
            await navigator.clipboard.writeText(value);
        } catch(error) {
            console.error(error);
        }
    };

    return (
        <Tooltip title={<Localized id="copy-to-clipboard">_Skopiuj do schowka</Localized>}>
            <span>
                <IconButton disabled={disabled} onClick={() => handleCopytoClipboardClick()}>
                    <ContentCopy/>
                </IconButton>
            </span>
        </Tooltip>
    );
};
